import React from 'react';
import Field from 'redux-form/lib/Field';
import { formValueSelector } from 'redux-form';
import { useSelector } from 'react-redux';
import { useIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';

import CommonFormComponent from '../../CommonField/CommonFormComponent';

import cs from '../../../components/commonStyle.css';
import s from './ConfigSettingsForm.css';
import messages from '../../../locale/jsonMessages';

const Recaptcha = () => {
  const { formatMessage } = useIntl();
  const selector = formValueSelector('ConfigSettingsForm');
  const reCaptchaStatus = useSelector(state => selector(state, 'reCaptchaStatus'));
  const version = reCaptchaStatus || 'v2';

  const renderFields = (version) => (
    ['SiteKey', 'SecretKey'].map((key) => {
      const name = version === 'v2' ?
        (key === 'SiteKey' ? 'v2Sitekey' : 'reCaptchaV2') :
        (key === 'SiteKey' ? 'v3Sitekey' : 'reCaptchaV3');
      const message = key === 'SiteKey' ? 'reCaptchaSiteKey' : 'reCaptchaSecretKey';
      const toolTip = key === 'SiteKey' ? 'reCaptchaSitekeyTooltip' : 'reCaptchaSecretKeyTooltip';

      return (
        <Field
          name={name}
          key={name}
          type="text"
          component={CommonFormComponent}
          placeholder={formatMessage({ id: message })}
          inputClass='commonInputField'
          labelText={formatMessage({ id: message })}
          toolTipText={formatMessage({ id: toolTip })}
        />
      );
    })
  );

  return (
    <div>
      <hr className={s.divider} />
      <h5 className='siteAdminSubHeading'><FormattedMessage  {...messages.reCaptchaLabel} /></h5>
      <div className='twoColumnGrid'>
        <Field
          name="reCaptchaStatus"
          type="text"
          inputClass='commonSelectField'
          component={CommonFormComponent}
          labelText={formatMessage(messages.reCaptchaVersion)}
          toolTipText={formatMessage(messages.reCaptchaVersionTooltip)}
          placeholder={formatMessage(messages.reCaptchaVersion)}
        >
          <option value="v2">{formatMessage(messages.v2)}</option>
          <option value="v3">{formatMessage(messages.v3)}</option>
        </Field>
        {(version === 'v2' || version === 'v3') && renderFields(version)}
      </div>
    </div>
  );
};


export default withStyles(s, cs)(Recaptcha);
